// @flow
import * as React from 'react';
import _ from 'lodash';
import Portal from './../common/Portal';
import Button from './Button';
import Row from './layout/Row';

import './ActionMenu.css';
import System from '../basic/System';

type Item = {
  label: string,
  className?: string,
  icon?: string,
  href?: string,
  divider?: boolean,
  onClick?: Function,
  onMenuOpen?: Function,
  onMenuClose?: Function
};

type Props = {
  icon: string,
  items?: Item[],
  children: any,
  anchor: 'LEFT' | 'RIGHT',
  theme: 'GRAY' | 'WHITE',
  dismissOnClick: boolean,
  fromComponent: String
};

type State = {
  isOpen: boolean,
  position: Object,
  style: Object
};

class ActionMenu extends React.PureComponent<Props, State> {
  static defaultProps = {
    icon: 'images/more.svg',
    anchor: 'LEFT',
    theme: 'GRAY',
    buttonType: 'plain',
    onMenuOpen: _.noop,
    onMenuClose: _.noop
  };

  state = {
    isOpen: false,
    position: {},
    style: {}
  };

  onRef = (node: ?HTMLDivElement) => {
    if (!node) {
      return;
    }

    const rect = node.getBoundingClientRect();
    const diffX = rect.right - window.innerWidth;
    const diffY = rect.bottom - window.innerHeight;
    const translate = [];
    if (diffX > 0) {
      translate.push(`translateX(-${diffX + 5}px)`);
    }
    if (diffY > 0) {
      translate.push(`translateY(-${diffY + 5}px)`);
    }

    if (translate.length) {
      this.setState({ style: { transform: translate.join(' ') } });
    }
  };

  onBackgroundClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget || this.props.dismissOnClick) {
      this.onClose();
    }
  };

  onTriggerClick = (e: Event) => {
    e.stopPropagation();
    const { anchor } = this.props;
    const rect = e.target.getBoundingClientRect();
    const position = {
      top: rect.bottom + 3
    };

    if (anchor === 'LEFT') {
      position.left = rect.left - 10;
    } else {
      position.right = window.innerWidth - rect.right - 10;
    }

    this.setState({ isOpen: true, position });
    this.props.onMenuOpen();
  };

  onItemClick = (cb: Function) => {
    if (!this.props.dismissOnClick) {
      this.setState({ isOpen: false });
      this.props.onMenuClose();
    }
    cb();
  };

  onClose = () => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
      this.props.onMenuClose();
    }
  };

  renderItem = (item: Item, i: number) => {
    if (item.divider) {
      return <div key={i} className="divider" />;
    }

    if (item.isComponent) {
      const Component = item.Component;
      return Component;
    }

    if (item.href) {
      return (
        <a key={i} className={item.className} href={item.href} target={System.isDesktop() ? "" : "_blank"}>
          <img src="images/external-link-dark-gray.svg" />
          <span>{item.label}</span>
        </a>
      );
    }

    return (
      <Row key={i} center="H">
        <Button
          type="PLAIN"
          className={item.className}
          icon={item.icon}
          text={item.label}
          onClick={() => this.onItemClick(item.onClick)}
        />
      </Row>
    );
  };

  render() {
    const { children, icon, anchor, theme, text, buttonType } = this.props;
    const { isOpen, position, style } = this.state;
    let items = [];
    let arrowStyle = {};
    if (anchor === 'LEFT') {
      arrowStyle.left = 11;
    } else {
      arrowStyle.right = 11;
    }

    if (isOpen) {
      items = this.props.getItems ? this.props.getItems() : this.props.items;
    }
    const col_View = this.props.fromComponent;
    const moreIcon =
      (col_View === 'CollectionGrid' && (this.props.isHovered || this.props.isSelected)) ||
        (col_View === 'CollectionList' && (this.props.isHovered || this.props.isSelected))
        ? true
        : false;
    return (
      <div name="ActionMenu">
        <Button  text={text} type={buttonType} icon={moreIcon ? 'images/more_black.svg' : icon} onClick={this.onTriggerClick} />
        {isOpen ? (
          <Portal preventEvent={'keydown'} defaultOpen={true} closeOnEsc closeOnOutsideClick onClose={this.onClose}>
            <div className="transparent-background" onClick={this.onBackgroundClick}>
              <div
                name="ActionMenu_Portal"
                style={{ ...position, ...style, background: 'var(--primary-header-bg)' }}
                className={`theme-${theme.toLowerCase()}`}
                ref={this.onRef}>
                {_.isEmpty(style) ? <span className="arrow" style={arrowStyle} /> : null}
                {children || items.map(this.renderItem)}
              </div>
            </div>
          </Portal>
        ) : null}
      </div>
    );
  }
}

export default ActionMenu;
